export const specialCoverages = {
  pregnant: 'Gestante',
  preoperative: 'Pré-operatório',
  postoperative: 'Pós-operatório',
};

export function getName(value) {
  return specialCoverages[value];
}
